import React from 'react'
import OfferChoice from "./OfferChoice";

function Index(
    {
        expanded
    }) {
    return (expanded && <OfferChoice />)
}


export default Index;